import BaseApi from 'api/core/baseApi';
import { ENDPOINTS } from 'api/config/endpoints';

class ChannelProductApi extends BaseApi {
  constructor() {
    super(ENDPOINTS.CHANNEL_PRODUCT);
  }

  linkProduct(productId, data) {
    return this.httpClient.patch(
      `${this.getResourceUrl()}${productId}/link/`,
      data,
    );
  }

  unlinkProduct(productId) {
    return this.httpClient.delete(`${this.getResourceUrl()}${productId}/link/`);
  }

  syncInventory(data) {
    return this.httpClient.post(
      `${this.getResourceUrl()}sync-inventory/`,
      data,
    );
  }

  syncChannelProduct() {
    return this.httpClient.post(
      `${this.getResourceUrl()}sync-channel-product/`,
    );
  }
}

export default new ChannelProductApi();
